import React from 'react'
import { Component } from 'react';
import Container from '../common/container/Container';
import { connect } from 'react-redux';
import { createSupplierRequest } from '../../store/actions/supplierFormActions'
import { withRouter } from 'react-router-dom';
import Step1Form from './components/step1/Step1Form';
import Step2Form from './components/step2/Step2Form';
import Step3Form from './components/step3/Step3Form';
import Step4Form from './components/step4/Step4Form';
import LoadingView from './components/loading/LoadingView';
import ConfirmView from './components/confirm/ConfirmView';
import './styles/SupplierFormScreen.css';

class SupplierFormScreen extends Component {
    state = {
        name: "",
        email: "",
        password: "",
        passwordConfirm: "",
        partitaIVA: "",
        ipa: "",
        registeredOfficeAddress: "",
        supplierName: "",
        companyName: "",
        description: "",
        imageFile: "",
        imagePreviewLink: "",
        phoneNumber: "",
        category: null,
        tags: [],
        iban: "",
        area: null,
        step: 0,
        error: "",
        address: "",
        zipCode: null,
        validAddress: false,
        addressError: "",
        coordinates: "",
        requestSent: false,
        adminPhoneNumber: "",
        notes: "",
        canUseOwnDrivers: false,
        supplierPercentageWithOwnDrivers: 0.8,
        deliveryAmountWithOwnDrivers: 3,
        hasPercentagePromo: false,
        promoEndDate: null,
        supplierPercentage: 0.75,
        promoSupplierPercentage: 0.85,
    }

    onBackButtonClick = () => {
        if (this.state.step > 0) {
            this.setState({ step: this.state.step - 1 });
        }
        else {
            this.props.history.push("/");
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.step === 2) {
            if (!this.state.imageFile) {
                this.setState({
                    error: "Immagine di profilo non selezionata."
                });
                return;
            }
            if (this.state.tags.length === 0) {
                this.setState({
                    error: "Tag dell'attività non selezionati."
                });
                return;
            }
        }
        else if (this.state.step === 3) {
            if (this.state.password !== this.state.passwordConfirm) {
                this.setState({
                    error: "Le password inserite non corrispondono."
                });
                return;
            }
            const iban = this.state.iban.replace(/\s/g, '');
            if (!(/^([a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16})$/.test(iban))) {
                this.setState({
                    error: "IBAN inserito non valido."
                });
                return;
            }

            this.props.createSupplierRequest({ ...this.state, iban });
            this.setState({ requestSent: true });
        }

        this.setState({ step: this.state.step + 1, error: "" });
    }

    handleChange = (id, value) => {
        this.setState({
            [id]: value,
        });
    }

    componentDidUpdate() {
        if (this.state.requestSent === true && this.props.requestLoading === false && this.props.requestError === true) {
            this.setState({ step: this.props.stepWithError, requestSent: false });
        }
        if (this.props.requestLoading && this.state.requestSent === false) {
            this.setState({ requestSent: true });
        }
    }

    handleAddressSelect = (data) => {
        this.setState({ ...data });
    }


    render() {
        var step1Form = <Step1Form onChange={this.handleChange} data={this.state} onAddressSelect={this.handleAddressSelect} />;
        var step2Form = <Step2Form onChange={this.handleChange} data={this.state} />;
        var step3Form = <Step3Form onChange={this.handleChange} data={this.state} />;
        var step4Form = <Step4Form onChange={this.handleChange} data={this.state} />;
        let body;

        if (this.state.requestSent) {
            if (this.props.requestLoading) {
                body = <LoadingView />;
            }
            else if (this.props.requestSuccess) {
                body = <ConfirmView />;
            }
        }

        else {
            body = <Container>
                <form onSubmit={this.handleSubmit} className="supplierForm">
                    {
                        this.state.step === 0 && step1Form
                    }
                    {
                        this.state.step === 1 && step2Form
                    }
                    {
                        this.state.step === 2 && step3Form
                    }
                    {
                        this.state.step === 3 && step4Form
                    }
                    <div className="text-danger">
                        {this.state.error !== "" ? <p>{this.state.error}</p> : null}
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-4 col-12 mt-3 back-container">
                            <button className="btn btn-outline-primary button" type="button" onClick={this.onBackButtonClick}>Indietro</button>
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 mt-3 next-container">
                            <button className="btn btn-primary button" disabled={!this.state.validAddress}>{this.state.step === 3 ? "Invia" : "Prosegui"}</button>
                        </div>
                    </div>
                </form>
            </Container>
        }

        return (
            <div className="supplier">
                {body}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        requestLoading: state.supplierForm.requestLoading,
        requestSuccess: state.supplierForm.requestSuccess,
        requestError: state.supplierForm.requestError,
        stepWithError: state.supplierForm.stepWithError,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createSupplierRequest: (data) => dispatch(createSupplierRequest(data)),
    }
}





export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierFormScreen));